enum assetsActionType {
    ASSETS_INIT_ASSETS = 'ASSETS_INIT_ASSETS',
    ASSET_EDIT_FILTER = 'ASSET_EDIT_FILTER',
    ASSET_RESET_FILTER = 'ASSET_RESET_FILTER',
    SEARCH_RESULT_SUCCESSFUL = 'SEARCH_RESULT_SUCCESSFUL',
    CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS',
    SET_SHOW_OTHER_DONORS = 'SET_SHOW_OTHER_DONORS',
}

export default assetsActionType